// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    CSRF: '/auth/csrf/',
    LOGIN: '/auth/login/',
    LOGOUT: '/auth/logout/',
    ME: '/auth/me/',
    UPDATE_PROFILE: '/auth/me/',
    CHANGE_PASSWORD: '/auth/me/change-password/',
  },

  // Users
  USERS: {
    LIST: '/v1/users/',
    DETAIL: '/v1/users/:id/',
    AUTOCOMPLETE: '/v1/users/autocomplete/',
  },

  // Activity logs (superadmin only)
  ACTIVITY_LOGS: {
    LIST: '/v1/activity-logs/',
    DETAIL: '/v1/activity-logs/:id/',
  },

  // Leads
  LEADS: {
    LIST: '/v1/leads/',
    CREATE: '/v1/leads/',
    DETAIL: '/v1/leads/:uuid/',
    UPDATE: '/v1/leads/:uuid/',
    DELETE: '/v1/leads/:uuid/',
    STATS: '/v1/leads/stats/',
  },

  // Buyers
  BUYERS: {
    AUTOCOMPLETE: '/v1/buyers/autocomplete/',
  },

  // Arendators
  ARENDATORS: {
    AUTOCOMPLETE: '/v1/arendators/autocomplete/',
  },

  // Geolocate (Regions & Cities)
  GEOLOCATE: {
    REGIONS_AUTOCOMPLETE: '/v1/geolocate/regions/autocomplete/',
    CITIES_AUTOCOMPLETE: '/v1/geolocate/cities/autocomplete/',
  },

  // Properties (Facility)
  PROPERTIES: {
    LIST: '/api/facility/',
    SALE: '/api/facility/sale/',
    RENT: '/api/facility/rent/',
    DEVELOPERS: '/api/facility/developers/',
    DETAIL: '/api/facility/:id/',
    DETAIL_OLD: '/api/facility/details/:id/',
  },

  // Clients
  CLIENTS: {
    LIST: '/crm/clients/',
    CREATE: '/crm/clients/new/',
    DETAIL: '/crm/clients/:id/',
    UPDATE: '/crm/clients/:id/edit/',
    DELETE: '/crm/clients/:id/delete/',
  },

  // Dashboard
  DASHBOARD: {
    STATS: '/dashboard/stats/',
  },
}

// API Response format (according to CRUD_Operations_Standards.md)
export const API_RESPONSE_FORMAT = {
  SUCCESS: {
    success: true,
    data: null, // or [] or {}
    message: null,
    error: null,
    meta: {},
    links: {}, // for pagination
  },
  ERROR: {
    success: false,
    data: null,
    message: null,
    error: {
      code: null,
      type: null,
      details: null,
      fields: {}, // validation errors
    },
    meta: {},
  },
}
